import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("ds_token"));
  const [firm, setFirm] = useState(null);
  const [loading, setLoading] = useState(true);

  const authHeader = useCallback(
    () => (token ? { Authorization: `Bearer ${token}` } : {}),
    [token]
  );

  const loadMe = useCallback(async () => {
    if (!token) {
      setFirm(null);
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setFirm(res.data);
    } catch (e) {
      localStorage.removeItem("ds_token");
      setToken(null);
      setFirm(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (phone, password) => {
    const res = await axios.post(`${API}/auth/login`, { phone, password });
    localStorage.setItem("ds_token", res.data.token);
    setToken(res.data.token);
    setFirm(res.data.firm);
    return res.data.firm;
  };

  const register = async (payload) => {
    const res = await axios.post(`${API}/auth/register`, payload);
    localStorage.setItem("ds_token", res.data.token);
    setToken(res.data.token);
    setFirm(res.data.firm);
    return res.data.firm;
  };

  const ssoLogin = async (ticket) => {
    const res = await axios.post(`${API}/partner/basitajanda/sso`, { ticket });
    localStorage.setItem("ds_token", res.data.token);
    setToken(res.data.token);
    setFirm(res.data.firm);
    return res.data.firm;
  };

  const logout = () => {
    localStorage.removeItem("ds_token");
    setToken(null);
    setFirm(null);
  };

  const refresh = loadMe;

  return (
    <AuthContext.Provider
      value={{ token, firm, setFirm, loading, login, register, ssoLogin, logout, refresh, authHeader, API }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
